export default __webpack_public_path__ + "static/media/live-logo.25b18407.webp";